<template>
    <div class="breadcrumb">
        <ul>
            <li @click="$router.push('/')">
                <img src="@/assets/images/home.png" alt="">
                <span>首页</span>
                <div class="arrow"></div>
            </li>
            <li>
                <span v-if="$route.fullPath.includes('/aboutUs')" @click="$router.push('/aboutUs')">关于我们</span>
                <span v-if="$route.fullPath.includes('/ourService')" @click="$router.push('/ourService')">我们的服务</span>
                <span v-if="$route.fullPath.includes('/joinUs')">加入我们</span>
                <div class="arrow" v-if="$route.name!='ourServiceMainPage' && $route.name!='joinUs'"></div>
            </li>
            <li v-if="$route.name=='enterpriseIntroduction'">企业简介</li>
            <li v-if="$route.name=='enterpriseCulture'">企业文化</li>
            <li v-if="$route.name=='developmentHistory'">发展历程</li>
            <li v-if="$route.name=='honor'">资质荣誉</li>
            <li v-if="$route.name=='laboratory'">健安德实验室</li>
            <li v-if="$route.name=='contactUs'">联系我们</li>
            <li v-if="$route.name=='ourServicePesticide'">农药登记试验</li>
            <li v-if="$route.name=='chemicalRegister'">新化学物质登记试验</li>
            <li v-if="$route.name=='makeUp'">化妆品注册和备案检验</li>
            <li v-if="$route.name=='otherService'">其他服务</li>
        </ul>
    </div>
</template>

<script>
export default {
  name: 'breadcrumb',
  data () {
    return {}
  },
  methods: {},
}
</script> 

<style lang='less' scoped>
    .breadcrumb{
        ul{
            display: flex;
            font-size: 14px;
            li{
                cursor: pointer;
                display: flex;
                align-items: center;
                color: #999999;
                img{
                    margin-right: 10px;
                }
                .arrow{
                    transform: rotate(45deg);
                    border-top: 1px solid #999999;
                    border-right: 1px solid #999999;
                    height: 6px;
                    width: 6px;
                    margin: 0 10px;
                }
                &:last-child{
                    color: #333333;
                }
            }
        }
    }
</style>
